import { Slider } from "./Slider.js";

/**
 * Class to implement the slider manager
 * as a singleton, which can be instantiated by
 * any other extension as a dependency
 */
export class SliderManager {
    private static manager: SliderManager;
    private instances: Slider[] = [];

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor() {
        this.sliders.forEach((slider) => {
            this.instances.push(new Slider(slider));
        });
    }

    /**
     * Method to instantiate all
     * sliders on the current page
     *
     * @param {boolean} [reset=false]
     * @returns {SliderManager}
     */
    public static use(reset: boolean = false): SliderManager {
        if (!SliderManager.manager || reset) {
            SliderManager.manager = new SliderManager();
        }
        return SliderManager.manager;
    }

    /**
     * Selects the sliders
     *
     * @returns {NodeListOf<HTMLElement>}
     */
    protected get sliders(): NodeListOf<HTMLElement> {
        return document.querySelectorAll(`[slider]:not([data-slider-manual])`);
    }

    /**
     * Returns the number of instantiated sliders
     *
     * @returns {number}
     */
    public get length(): number {
        return this.instances.length;
    }
}
